import React from 'react';
import Menu from './Menu';

class SiteFooter extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
        // select element to unwrap
        let el = document.querySelector('nav');

        // get the element's parent node
        let parent = el.parentNode;

        // move all children out of the element
        while (el.firstChild) parent.insertBefore(el.firstChild, el);

        // remove the empty element
        parent.removeChild(el);
    }


    render() {
        
        // let cls = this.props.className ? ' '+this.props.className : ''
        return (
            <footer className="section">
                <Menu  {...this.props}  />
            </footer>
        );
    }
}
export default SiteFooter;


// WEBPACK FOOTER //
// ./src/components/inc/Footer.js